import React from "react"

function Leaf({ width = 24, height = 24, fill = "none", ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="6 6 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.7074 22.174C7.79468 14.5312 14.1171 8.5716 24.2955 11.0102C25.0133 11.1822 25.5067 11.8414 25.4708 12.5786C25.1552 19.0732 22.1951 22.7538 13.1104 22.9879C12.5252 23.003 11.9742 22.6952 11.7074 22.174Z"
        stroke="#003E4C"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.3333 25.5002C12.5834 20.9169 13 18.4169 18 16.3335"
        stroke="#003E4C"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export default Leaf
